import { useFormContext } from 'react-hook-form';

import { Box, useTheme } from '@mui/material';
import { EditCTAButtonsProps, ScorecardToSubmit } from '../../../../types/scorecardTypes';
import { PrimaryButton } from 'sharedComponents/Buttons';
import { primaryButtonOverrideSx } from 'sharedComponents/Buttons/styles';
import { GreySecondaryButton } from 'sharedComponents/Buttons/GreySecondaryButton';
import { ATSConnectHiringRequestCreateFeedbackTestIds } from 'data-testids/ATS';

export const EditCTAButtons: React.FC<EditCTAButtonsProps> = ({ onCancel, isLoading, onSave }) => {
  const theme = useTheme();
  const {
    handleSubmit,
    formState: { errors },
    watch,
    reset,
  } = useFormContext<ScorecardToSubmit>();

  const cumulativeScore = watch('cumulative_score');
  const maxScore = watch('max_cumulative_score');

  const submitShouldBeDisabled =
    Object.keys(errors).length > 0 || cumulativeScore > maxScore || isLoading;

  return (
    <Box
      sx={{
        paddingTop: theme.spacing(4),
        width: '100%',
        display: 'flex',
        justifyContent: 'end',
      }}
    >
      <GreySecondaryButton
        onClick={() => {
          reset();
          onCancel();
        }}
        dataTestId={ATSConnectHiringRequestCreateFeedbackTestIds.EDIT_CANCEL_BUTTON}
        sx={{
          width: '50%',
          marginRight: theme.spacing(1),
        }}
      >
        Cancel
      </GreySecondaryButton>
      <PrimaryButton
        onClick={handleSubmit(onSave)}
        disabled={submitShouldBeDisabled}
        sx={{ ...primaryButtonOverrideSx(theme), width: '50%' }}
      >
        Save Changes
      </PrimaryButton>
    </Box>
  );
};
